import { gql } from '@apollo/client'

export const SEND_POSTAL_CHANGE_JOB = gql`
    mutation sendPostalChangeJob($input: PostalChangeInput!) {
        sendPostalChangeJob(input: $input)
    }
`
